import { StageCard } from '@/comp/StationStages/styled';
import { Table } from 'antd';
import styled from 'styled-components';
import { breakpoints } from '@/utils/util-breakpoints';

export const ReportsTabPageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .engine-header-container {
    display: flex;
    align-items: center;
    gap: 10rem;
    margin-top: ${({ theme: { token } }) => token.marginMD}px;
    padding-left: ${({ theme: { token } }) => token.paddingXL}px;
    flex-shrink: 0;

    @media (max-width: 1024px) {
      flex-direction: column-reverse;
      align-items: stretch;
      gap: 1.5rem;
    }

    @media (max-width: ${breakpoints.md}px) {
      padding-left: ${({ theme: { token } }) => token.paddingMD}px;
      padding-right: ${({ theme: { token } }) => token.paddingMD}px;
      margin-top: ${({ theme: { token } }) => token.marginSM}px;
    }

    ${StageCard} {
      margin: ${({ theme: { token } }) => token.marginMD}px 0;
      flex: 1;
    }

    .eco-select-station {
      min-width: 20rem;
      width: 20rem;

      @media (max-width: 1024px) {
        width: 100%;
      }

      @media (max-width: ${breakpoints.md}px) {
        min-width: 100%;
      }
    }
  }

  .table-container {
    margin: ${({ theme: { token } }) => token.marginXL}px;
    background: ${({ theme: { token } }) => token.colorBgContainer};
    border-radius: ${({ theme: { token } }) => token.borderRadius}px;
    overflow: hidden;
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    max-height: calc(100vh - 220px);

    @media (max-width: ${breakpoints.md}px) {
      margin: ${({ theme: { token } }) => token.marginSM}px;
      max-height: calc(100vh - 180px);
      border-radius: ${({ theme: { token } }) => token.borderRadiusSM}px;
    }
  }

  .reports-header-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: ${({ theme: { token } }) => token.marginXL}px;
    margin-right: ${({ theme: { token } }) => token.marginXL}px;
    margin-top: ${({ theme: { token } }) => token.marginXL}px;

    @media (max-width: ${breakpoints.md}px) {
      flex-direction: column;
      align-items: flex-start;
      gap: ${({ theme: { token } }) => token.marginMD}px;
      margin-left: ${({ theme: { token } }) => token.marginSM}px;
      margin-right: ${({ theme: { token } }) => token.marginSM}px;
      margin-top: ${({ theme: { token } }) => token.marginMD}px;
    }
  }

  .total-reports-text {
    display: flex;
    align-items: center;
    gap: ${({ theme: { token } }) => token.marginXS}px;
  }

  .total-reports-text-title {
    font-size: ${({ theme: { token } }) => token.fontSizeHeading3 || token.fontSizeLG * 1.5}px;
    font-weight: 700;
    color: ${({ theme: { token } }) => token.colorText};

    @media (max-width: ${breakpoints.md}px) {
      font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
    }
  }

  .total-reports-count {
    font-size: ${({ theme: { token } }) => token.fontSizeHeading3 || token.fontSizeLG * 1.5}px;
    font-weight: 700;
    color: ${({ theme: { token } }) => token.colorText};

    @media (max-width: ${breakpoints.md}px) {
      font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
    }
  }

  .header-right-section {
    display: flex;
    align-items: center;
    gap: ${({ theme: { token } }) => token.marginMD}px;

    @media (max-width: ${breakpoints.md}px) {
      width: 100%;
    }
  }

  .create-report-button-container {
    margin: 0;

    @media (max-width: ${breakpoints.md}px) {
      width: 100%;
      
      button {
        width: 100%;
      }
    }
  }

  .search-filter-section {
    margin: 0;
    min-width: 17rem;
    width: 10rem;

    @media (max-width: ${breakpoints.md}px) {
      min-width: 100%;
      width: 100%;
    }
  }

  .search-suffix {
    cursor: pointer;
  }

  .search-icon {
    color: ${({ theme: { token } }) => token.colorText};
  }
`;

export const StyledTable = styled(Table)`
  height: 100%;
  display: flex;
  flex-direction: column;

  .ant-table-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    border-left: none !important;
    border-right: none !important;
  }

  .ant-table {
    background: ${({ theme: { token } }) => token.colorBgTextHover};
    flex: 1;
    display: flex;
    flex-direction: column;
    border-left: none !important;
    border-right: none !important;
  }

  .ant-table-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    border-left: none !important;
    border-right: none !important;
    overflow-x: auto;
  }

  .ant-table-body {
    flex: 1;
    overflow-y: auto;
    max-height: calc(100vh - 340px);

    @media (max-width: ${breakpoints.md}px) {
      max-height: calc(100vh - 280px);
    }

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: ${({ theme: { token } }) => token.colorBgLayout};
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: ${({ theme: { token } }) => token.colorBorderSecondary};
      border-radius: 3px;

      &:hover {
        background: ${({ theme: { token } }) => token.colorBorder};
      }
    }
  }

  /* Hide scrollbar for empty table state */
  .ant-table-placeholder {
    .ant-table-cell {
      border-bottom: none !important;
    }
  }

  .ant-table-empty .ant-table-body {
    overflow: hidden;
  }

  .ant-table-thead > tr > th {
    background: ${({ theme: { token } }) => token.colorBgElevated};
    color: ${({ theme: { token } }) => token.colorText};
    border-bottom: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
    border-left: none !important;
    border-right: none !important;
    padding: ${({ theme: { token } }) => token.paddingMD}px ${({ theme: { token } }) => token.paddingMD}px;
    position: relative;
    white-space: nowrap;

    @media (max-width: ${breakpoints.md}px) {
      padding: ${({ theme: { token } }) => token.paddingSM}px ${({ theme: { token } }) => token.paddingXS}px;
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    }
  }

  .ant-table-thead > tr > th.ant-table-cell {
    border-left: none !important;
    border-right: none !important;
  }

  .ant-table-thead > tr > th::before {
    display: none !important;
  }

  /* Add vertical separator between columns, but exclude first column (expand icon) and last column */
  .ant-table-thead > tr > th:not(:first-child):not(:last-child)::after {
    content: '';
    position: absolute;
    right: 0;
    top: ${({ theme: { token } }) => token.marginSM}px;
    bottom: ${({ theme: { token } }) => token.marginSM}px;
    width: 2px;
    background: ${({ theme: { token } }) => token.colorBorderSecondary};

    @media (max-width: ${breakpoints.md}px) {
      display: none;
    }
  }

  .ant-table-tbody > tr > td {
    background: ${({ theme: { token } }) => token.colorBgContainer};
    color: ${({ theme: { token } }) => token.colorText};
    border-bottom: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
    border-left: none !important;
    border-right: none !important;
    padding: ${({ theme: { token } }) => token.paddingMD}px ${({ theme: { token } }) => token.paddingMD}px;

    @media (max-width: ${breakpoints.md}px) {
      padding: ${({ theme: { token } }) => token.paddingSM}px ${({ theme: { token } }) => token.paddingXS}px;
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    }
  }

  .ant-table-tbody > tr:hover > td {
    background: ${({ theme: { token } }) => token.colorBgTextHover};
  }

  .ant-table-tbody > tr > td.ant-table-cell {
    border-left: none !important;
    border-right: none !important;
  }

  .ant-table-expanded-row {
    > td {
      padding: 0 !important;
      padding-left: 50px !important; /* Shift content to align with first data column */
      border-bottom: none !important;
      position: relative;
      overflow: visible;

      @media (max-width: ${breakpoints.md}px) {
        padding-left: ${({ theme: { token } }) => token.paddingSM}px !important;
      }
    }
  }

  .ant-table-expanded-row-level-1 {
    > td {
      padding: 0 !important;
    }
  }

  .ant-table-expanded-row .ant-table-wrapper {
    margin: 0 !important;
  }

  .ant-table-expanded-row .ant-table {
    margin: 0 !important;
  }

  .ant-pagination {
    padding: ${({ theme: { token } }) => token.paddingMD}px;
    margin: 0 !important;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    flex-shrink: 0;

    @media (max-width: ${breakpoints.md}px) {
      padding: ${({ theme: { token } }) => token.paddingSM}px;
      justify-content: center;
      
      .ant-pagination-total-text {
        display: none;
      }

      .ant-pagination-options {
        display: none;
      }
    }

    &::-webkit-scrollbar {
      height: 6px;
    }

    &::-webkit-scrollbar-track {
      background: ${({ theme: { token } }) => token.colorBgLayout};
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: ${({ theme: { token } }) => token.colorBorderSecondary};
      border-radius: 3px;

      &:hover {
        background: ${({ theme: { token } }) => token.colorBorder};
      }
    }
  }
`;

export const ChildRow = styled.div`
  display: grid;
  grid-template-columns: 30% 18% 18% 18% 16%;
  padding: 14px 20px 14px 54px; 
  background: ${({ theme: { token } }) => token.colorBgLayout};
  border-bottom: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};

  @media (max-width: ${breakpoints.md}px) {
    display: flex;
    flex-direction: column;
    gap: ${({ theme: { token } }) => token.marginSM}px;
    padding: ${({ theme: { token } }) => token.paddingSM}px;
  }

  span {
    display: flex;
    align-items: center;
  }

  .child-row-report-details {
    margin-left: 10px;

    @media (max-width: ${breakpoints.md}px) {
      margin-left: 0;
      font-weight: 600;
      font-size: ${({ theme: { token } }) => token.fontSize}px;
    }
  }

  .child-row-date {
    margin-left: 10px;

    @media (max-width: ${breakpoints.md}px) {
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      color: ${({ theme: { token } }) => token.colorTextSecondary};

      &::before {
        content: 'Date: ';
        color: ${({ theme: { token } }) => token.colorTextTertiary};
      }
    }
  }

  .child-row-created-by {
    margin-left: 10px;

    @media (max-width: ${breakpoints.md}px) {
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      color: ${({ theme: { token } }) => token.colorTextSecondary};

      &::before {
        content: 'By: ';
        color: ${({ theme: { token } }) => token.colorTextTertiary};
      }
    }
  }

  .child-row-status {
    margin-left: 0;
  }

  .child-row-status-content {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .child-row-actions {
    display: flex;
    justify-content: flex-end;
    padding-right: 40px;
    gap: 8px;
    align-items: center;

    @media (max-width: ${breakpoints.md}px) {
      justify-content: flex-start;
      padding-right: 0;
      margin-top: ${({ theme: { token } }) => token.marginXS}px;
    }
  }

  .child-row-view-button {
    padding: 0;
    color: ${({ theme: { token } }) => token.colorPrimary};
  }

  
`;

export const StatusDot = styled.div<{ $backgroundColor: string }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${({ $backgroundColor }) => $backgroundColor};
`;

export const ExpandIcon = styled.span<{ $expanded: boolean }>`
  cursor: pointer;
  transform: ${({ $expanded }) => $expanded ? 'rotate(90deg)' : 'rotate(0deg)'};
  transition: 0.2s ease;
  margin-right: 8px;
  color: ${({ theme: { token } }) => token.colorTextSecondary};
  display: inline-flex;
  align-items: center;
`;

export const ReportPopupStyles = styled.div`
  .report-popup-container {
    position: relative;
    display: inline-block;

    @media (max-width: ${breakpoints.md}px) {
      width: 100%;
    }
  }

  .report-popup-card {
    position: absolute;
    width: 281px;
    height: 342px;
    max-width: calc(100vw - 32px);
    background: ${({ theme: { token } }) => token.colorBgElevated || '#2c3543'};
    padding: ${({ theme: { token } }) => token.paddingMD || 16}px;
    border-radius: ${({ theme: { token } }) => token.borderRadiusLG || 16}px;
    color: ${({ theme: { token } }) => token.colorText || '#ffffff'};
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4);
    z-index: 1001;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    box-sizing: border-box;

    @media (max-width: ${breakpoints.md}px) {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: calc(100vw - 32px);
      max-height: 90vh;
      height: auto;
    }
  }

  .report-popup-arrow {
    position: absolute;
    top: -8px;
    left: 90%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid ${({ theme: { token } }) => token.colorBgElevated || '#2c3543'};
    z-index: 1;

    @media (max-width: ${breakpoints.md}px) {
      display: none;
    }
  }

  .report-popup-close-btn {
    position: absolute;
    right: ${({ theme: { token } }) => token.paddingXS || 8}px;
    top: ${({ theme: { token } }) => token.paddingXS || 8}px;
    font-size: 20px;
    color: ${({ theme: { token } }) => token.colorTextSecondary || '#cbd5e1'};
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.7;
    }
  }

  .report-popup-icon {
    margin: 0 auto ${({ theme: { token } }) => token.marginSM || 12}px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 120px;
      height: 120px;
      object-fit: contain;
      left: -50%;
      position: relative;
    }
  }

  .report-popup-title {
    font-size: ${({ theme: { token } }) => token.fontSizeXL || 14}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong || 600};
    margin: 0 0 ${({ theme: { token } }) => token.marginXS || 8}px 0;
    text-align: left;
    line-height: 1.4;
    color: ${({ theme: { token } }) => token.colorText || '#ffffff'};
    width: 100%;
    word-wrap: break-word;
  }

  .report-popup-description {
    color: ${({ theme: { token } }) => token.colorTextSecondary || '#cbd5e1'};
    font-size: ${({ theme: { token } }) => token.fontSize || 12}px;
    margin: 0 0 ${({ theme: { token } }) => token.marginSM || 12}px 0;
    text-align: left;
    line-height: 1.5;
    width: 100%;
    word-wrap: break-word;
  }

  .report-popup-action-btn {
    background: ${({ theme: { token } }) => token.colorBgContainer || '#007bff'};
    border: 1px solid ${({ theme: { token } }) => token.colorBorder || '#9bb3d1'};
    color: ${({ theme: { token } }) => token.colorText || '#ffffff'};
    padding: ${({ theme: { token } }) => token.paddingXS || 8}px ${({ theme: { token } }) => token.paddingMD || 16}px;
    border-radius: ${({ theme: { token } }) => token.borderRadius || 8}px;
    cursor: pointer;
    font-size: ${({ theme: { token } }) => token.fontSizeSM || 12}px;
    transition: all 0.2s;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong || 500};
    align-self: flex-end;
    margin-right: 0;
    margin-bottom: 0;
    margin-top: auto;

    &:hover {
      background: ${({ theme: { token } }) => token.colorBgTextHover || '#3a4554'};
      border-color: ${({ theme: { token } }) => token.colorPrimary || '#87cefa'};
    }
  }
`;

export const CreateNewReportModalStyles = styled.div`
  .create-new-report-modal-content {
    display: flex;
    flex-direction: column;
    gap: ${({ theme: { token } }) => token.marginMD}px;
    padding: ${({ theme: { token } }) => token.paddingMD}px 0 ${({ theme: { token } }) => token.paddingSM}px 0;
  }

  .time-frame-info {
    display: flex;
    align-items: center;
    gap: ${({ theme: { token } }) => token.marginXS}px;
    padding: ${({ theme: { token } }) => token.paddingSM}px ${({ theme: { token } }) => token.paddingMD}px;
    background: ${({ theme: { token } }) => token.colorInfoBg || '#e6f7ff'};
    border-radius: ${({ theme: { token } }) => token.borderRadiusSM}px;
    border: 1px solid ${({ theme: { token } }) => token.colorInfoBorder || '#91d5ff'};

    .info-icon {
      color: ${({ theme: { token } }) => token.colorInfo || token.colorPrimary};
      font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
      flex-shrink: 0;
    }

    span {
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      color: ${({ theme: { token } }) => token.colorText};
    }
  }

  .date-range-picker-container {
    width: 100%;

    .select-dates {
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong || 500};
      color: ${({ theme: { token } }) => token.colorText};
      margin-bottom: ${({ theme: { token } }) => token.marginSM}px;
    }

    .ant-picker {
      width: 100%;
      min-width: 420px;

      @media (max-width: ${breakpoints.md}px) {
        min-width: 100%;
      }
    }
  }

  .report-description-container {
    display: flex;
    align-items: flex-start;
    gap: ${({ theme: { token } }) => token.marginXS}px;
    padding: ${({ theme: { token } }) => token.paddingSM}px;
    background: transparent;

    .note-icon {
      color: ${({ theme: { token } }) => token.colorInfo || token.colorPrimary};
      font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
      margin-top: ${({ theme: { token } }) => token.marginXXS}px;
      flex-shrink: 0;
    }

    .report-description-text {
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      color: ${({ theme: { token } }) => token.colorText};
      line-height: 1.5;
      flex: 1;
    }
  }

  .straight-line {
    width: calc(100% + 48px);
    height: 1px;
    background: ${({ theme: { token } }) => token.colorBorderSecondary};
    margin: ${({ theme: { token } }) => token.marginSM}px -24px;
  }

  .create-report-button-container {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export const DeleteReportModalStyles = styled.div`
  .delete-report-modal-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: ${({ theme: { token } }) => token.paddingMD}px 0;
  }

  .delete-report-icon {
    font-size: 48px;
    color: ${({ theme: { token } }) => token.colorWarning};
    margin-bottom: ${({ theme: { token } }) => token.marginMD}px;
  }

  .delete-report-title {
    font-size: ${({ theme: { token } }) => token.fontSizeHeading4 || token.fontSizeLG}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong || 600};
    color: ${({ theme: { token } }) => token.colorText};
    margin-bottom: ${({ theme: { token } }) => token.marginSM}px;
  }

  .delete-report-description {
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    margin-bottom: ${({ theme: { token } }) => token.marginLG}px;
    line-height: 1.5;
  }

  .delete-report-actions {
    display: flex;
    justify-content: center;
    gap: ${({ theme: { token } }) => token.marginMD}px;
    width: 100%;
  }
`;

export const PublishModalStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { token } }) => token.marginMD}px;
  padding: ${({ theme: { token } }) => token.paddingMD}px 0 ${({ theme: { token } }) => token.paddingSM}px 0;

  .publish-modal-description {
    margin-bottom: ${({ theme: { token } }) => token.marginXS}px;

    .publish-modal-description-text {
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      color: ${({ theme: { token } }) => token.colorText};
      line-height: 1.5;
    }
  }

  .publish-modal-input {
    display: flex;
    flex-direction: column;
    gap: ${({ theme: { token } }) => token.marginXS}px;
    width: 100%;

    .publish-modal-input-label {
      .publish-modal-input-label-text {
        font-size: ${({ theme: { token } }) => token.fontSize}px;
        font-weight: ${({ theme: { token } }) => token.fontWeightStrong || 500};
        color: ${({ theme: { token } }) => token.colorText};
      }
    }

    .publish-modal-input-wrapper {
      display: flex;
      align-items: center;
      width: 100%;
      border: 1px solid ${({ theme: { token } }) => token.colorBorder};
      border-radius: ${({ theme: { token } }) => token.borderRadius}px;
      background: ${({ theme: { token } }) => token.colorBgContainer};
      overflow: hidden;

      &.publish-modal-input-wrapper-error {
        border-color: ${({ theme: { token } }) => token.colorError || '#ff544e'};
      }

      .publish-modal-input-prefix {
        display: flex;
        align-items: center;
        padding: 0 ${({ theme: { token } }) => token.paddingSM}px;
        background: ${({ theme: { token } }) => token.colorBgContainer};

        .publish-modal-input-dollar {
          font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
          font-weight: ${({ theme: { token } }) => token.fontWeightRegular};
          color: ${({ theme: { token } }) => token.colorTextSecondary};
          margin-right: ${({ theme: { token } }) => token.marginSM}px;
        }

        .publish-modal-input-divider {
          width: 1px;
          height: 24px;
          background: ${({ theme: { token } }) => token.colorBorder};
        }
      }

      .publish-modal-input-field {
        flex: 1;
        border: none;
        border-radius: 0;

        &.ant-input {
          border: none;
          box-shadow: none;
          
          &:focus {
            box-shadow: none;
          }
        }
      }
    }

    .publish-modal-input-error {
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      color: ${({ theme: { token } }) => token.colorError || '#ff544e'};
      margin-top: ${({ theme: { token } }) => token.marginXS}px;
      line-height: 1.5;
    }
  }

  .report-description-container {
    display: flex;
    align-items: flex-start;
    gap: ${({ theme: { token } }) => token.marginXS}px;
    padding: ${({ theme: { token } }) => token.paddingSM}px;
    background: transparent;

    .note-icon {
      color: ${({ theme: { token } }) => token.colorInfo || token.colorPrimary};
      font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
      margin-top: ${({ theme: { token } }) => token.marginXXS}px;
      flex-shrink: 0;
    }

    .report-description-text {
      font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
      color: ${({ theme: { token } }) => token.colorTextSecondary};
      line-height: 1.5;
      flex: 1;
    }
  }

  .publish-modal-button {
    display: flex;
    justify-content: flex-end;
    gap: ${({ theme: { token } }) => token.marginSM}px;
    width: 100%;
    margin-top: ${({ theme: { token } }) => token.marginXS}px;
  }
`;

